<template>
  <div>
    <header-slot>
      <template v-slot:content-right>
        <div class="mr-2">
          <b-button
            v-b-tooltip.hover.left="$t('Register New Employee')"
            v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="outline-success"
            @click="sidebarEmployee = true"
            :disabled="true"
          >
            <div class="d-flex justify-content-between">
              <span v-t="'CREATE'"></span>
            </div>
          </b-button>

          <b-button
            v-b-tooltip.hover.left="$t('UPDATE EMPLOYEES')"
            v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="outline-primary"
            @click="addNewEmployees"
            class="ml-1"
          >
            <div class="d-flex justify-content-between">
              <span v-t="'UPDATE EMPLOYEES'"></span>
            </div>
          </b-button>
        </div>
      </template>
    </header-slot>

    <!-- <GridTable v-if="filters" :filters="filters" /> -->
    <b-nav card-header pills class="m-0">
      <b-nav-item
        v-for="(item, index) in tabs"
        :key="index"
        :to="{ name: item.name }"
        exact
        exact-active-class="active"
        :link-classes="['px-3', bgTabsNavs]"
        >{{ $t(item.title) }}
      </b-nav-item>
    </b-nav>
    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <router-view ref="routerViewTab" :key="routeName" />
    </b-card>

    <EmployeeSidebar
      v-if="sidebarEmployee"
      @hideSidebar="hideSidebarEmployee"
    />
    <!-- <ModalEmployee v-if="modalEmployee" @hideModal="hideModalEmployee" /> -->
  </div>
</template>


<script>
/* SERVICES */
import Ripple from "vue-ripple-directive";
import ModalEmployee from "@/views/rrhh/views/employees/components/modal/ModalEmployee.vue";
import Filters from "@/views/rrhh/views/employees/data/Filters.data";
import EmployeeServices from "@/views/rrhh/views/employees/services/employee.service";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import EmployeeSidebar from "@/views/rrhh/views/employees/components/sidebar/CreateEmployeeSidebar.vue";

export default {
  name: "Employees",
  components: {
    ModalEmployee,
    EmployeeSidebar,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      sidebarEmployee: false,
      filters: false,
    };
  },
  created() {
    this.getEntityGroups();
  },
  computed: {
    tabs() {
      return this.$route.matched[1].meta.tabs;
    },
    routeName() {
      return this.$route.name;
    },
  },
  methods: {
    async getEntityGroups() {
      const { data } = await EmployeeServices.getEntitiesGroup();
      this.filters = Filters;
      this.filters[3].options = data;
    },

    hideSidebarEmployee(action = false) {
      if (action == true) {
        // this.$refs.routerViewTab.refreshTable();
      }
      this.sidebarEmployee = false;
    },

    async addNewEmployees() {
      try {
        const confirm = await this.showConfirmSwal();
        if (confirm.isConfirmed) {
          this.addPreloader();
          const { data } = await EmployeeServices.getLastEmployeeId({});
          if (data.length > 0) {
            const form_params = new URLSearchParams();
            form_params.append(
              "data",
              JSON.stringify({
                id: data[0].id,
                token: "sfgdshfiuhfgsd7w9t874w9erfhu54k435df",
              })
            );

            const data2 = await EmployeeServices.getNewsPersonalsOldSoft(
              form_params
            );
            if (data2.data.personals.length > 0) {
              this.showToastSuccess(
                `${data2.data.personals.length} personales encontrados.`,
                "Success"
              );
              const data3 = await EmployeeServices.insertNewsEmployeesOfOldSot({
                employees: JSON.stringify(data2.data.personals),
              });
              this.showToastSuccess("Nuevos Personales insertados", "Success");
            } else {
              this.showToastSuccess(
                "No se encontraron nuevos Empleados",
                "Success"
              );
            }
          } else {
            this.showToastSuccess("No se encontraron registros", "Success");
          }
        }
      } catch (error) {
        this.showToastError();
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>
    
    
    